import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import RootState from './RootState';

import { authentication } from './authentication.module';
import { app } from './app.module';
import { notification } from './notification.module';
import { distributor } from './distributor.module';
import { diamond } from './diamond.module';

//import {search} from '@/store/search.module';

Vue.use(Vuex);

const options: StoreOptions<RootState> = {
  state: {
    version: '1.0.0',
  },
  modules: {
    auth: authentication,
    app,
    notification,
    distributor,
    diamond
    // search,
  },
};

export default new Vuex.Store<RootState>(options);


